import React, { useState } from 'react'

import { useQuery } from '@tanstack/react-query'
import { Check } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { cn } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { CommandGroup, CommandItem, CommandSeparator } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SchemaType } from './RunManualTaskForm.schema.js'

export interface RunManualTaskFormFieldsProps {}

export const RunManualTaskFormFields: React.FC<RunManualTaskFormFieldsProps> = ({}) => {
  const { setValue, control } = useFormContext<SchemaType>()
  const [open, setOpen] = useState(true)

  const api = useApi()

  const taskListQuery = useQuery({
    queryKey: ['logs', 'scheduled-tasks', 'list'],
    queryFn: () => api.feeds.getScheduledTaskList(),
  })

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="task_id"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Task</FormLabel>
              <SearchSelect
                open={open}
                setOpen={setOpen}
                value={value}
                loading={taskListQuery.isFetching}
                placeholder={'Select a task...'}
                options={Object.entries(taskListQuery.data?.data ?? {}).reduce(
                  (prev, [_currentGroupKey, currentGroupRecord]) => {
                    return [
                      ...prev,
                      ...Object.keys(currentGroupRecord).map((key) => ({ label: key, value: key })),
                    ]
                  },
                  [] as { label: string; value: string }[],
                )}
              >
                {Object.entries(taskListQuery.data?.data ?? {}).map(
                  ([label, groupRecord], index) => {
                    return (
                      <React.Fragment key={label}>
                        {index !== 0 && <CommandSeparator />}
                        <CommandGroup heading={label.toUpperCase()}>
                          {Object.keys(groupRecord).map((key) => {
                            const is_selected = key === value

                            return (
                              <CommandItem
                                value={key?.toString()}
                                onSelect={(val) => {
                                  // @ts-ignore
                                  setValue('task_id', val ? val : null, { shouldValidate: true })
                                  setOpen(false)
                                }}
                                disabled={is_selected}
                                key={key}
                              >
                                <div className={'flex items-center gap-2 justify-between w-full'}>
                                  <span>{key}</span>
                                  {is_selected && (
                                    <Check className={cn('text-green-700 ml-auto h-4 w-4')} />
                                  )}
                                </div>
                              </CommandItem>
                            )
                          })}
                        </CommandGroup>
                      </React.Fragment>
                    )
                  },
                )}
              </SearchSelect>
            </FormItem>
          )
        }}
      />
    </div>
  )
}
